import { render } from "./index.vue?vue&type=template&id=6cc1d364"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/login-invited-user-set-password/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cc1d364"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cc1d364', __exports__)) {
    api.reload('6cc1d364', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6cc1d364", () => {
    api.rerender('6cc1d364', render)
  })

}


export default __exports__